<template>
	<div class="header-nav">
		<div class="prev" v-if="prev" @click="handlerPrev">
			<img class="ico" src="~assets/images/icon-prev.png" />
		</div>
		<div class="title">{{name}}</div>
	</div>
</template>

<script>
	export default{
		name: 'HeaderBar',
		components: {
			
		},
		props: {
			name: {
				type: String,
				default: ''
			},
			prev: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				icon: require('assets/images/icon-prev.png')
			}
		},
		methods: {
			// 后退
			handlerPrev: function(){
				this.$router.go(-1)
			}
		},
		mounted: function(){
			
		}
	}
</script>

<style scoped>
.header-nav{ position: fixed; top: 0; left: 0; right: 0; height: 0.88rem; background: #3f58fd; z-index: 777; display: flex; justify-content: center; align-items: center;}
.header-nav>.title{ height: 0.88rem; line-height: 0.88rem; color: #FFF; font-size: 0.32rem;}
.header-nav>.prev{ position: absolute; left: 0; top: 50%; width: 0.88rem; height: 0.88rem; display: flex; justify-content: center; align-items: center; transform: translateY(-50%);}
.header-nav>.prev>.ico{ width: 0.36rem; height: 0.36rem;}
</style>